<template>

    <div>
        <WaitingPrice
            :entity-type="BUSINESS_TYPE.ENTITY"
            :entity-id="+$route.params.id"
        >
            <template v-slot:tabs>
                <EntityTabLinks />
            </template>
        </WaitingPrice>
    </div>

</template>

<script>
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import WaitingPrice from '@/components/waiting-price/WaitingPrice';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityWaitingPrice',

        components: {
            EntityTabLinks,
            WaitingPrice
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
